import * as actionTypes from '../constants/actionTypes';

const initialState = {
  user: {
    lifeTime: null,
    roles: [],
    login: null,
    firstName: null,
    lastName: null,
  },
};

const handleUser = (state = initialState, action) => {
  switch (action.type) {
    // pisz we should merge this and FETCH_USER_PROFILE_SUCCESS types, because we get all info from one token
    case actionTypes.FETCH_TOKEN_INFO_SUCCESS:
      /* eslint-disable */
      const {
        given_name,
        family_name,
        employeeid,
        lifeTime, // pisz what is this lifeTime? IPhone?
      } = action.token;
      // pisz || null is ugly, we should change this somehow
      return {
        ...state,
        user: {
          ...state.user,
          firstName: given_name || null,
          lastName: family_name || null,
          login: employeeid || null,
          lifeTime,
        },
      };
    case actionTypes.FETCH_USER_PROFILE_SUCCESS:
      return { ...state, user: { ...state.user, ...action.user } };
    case actionTypes.LOG_OUT:
      return { ...state, user: initialState.user };
    default:
      return state;
  }
};

export default handleUser;
